import HttpService from './HttpService';

export default class SettingService extends HttpService {
    endPoint = "/v1/settings"

    edit(data) {
        return this.getAuthTokenRequest()
            .patch(this.endPoint, data);
    }

    getDefault() {
        return this.getJsonRequest().get(this.endPoint + "/default");
    }

    getProfile() {
        return this.getJsonRequest().get(this.endPoint + "/profile");
    }

    getAccount() {
        return this.getJsonRequest().get(this.endPoint + "/account");
    }

    getRawDefault() {
        return this.getAuthTokenRequest().get(this.endPoint + "/raw-default");
    }

    getRawProfile() {
        return this.getAuthTokenRequest().get(this.endPoint + "/raw-profile");
    }

    getRawAccount() {
        return this.getAuthTokenRequest().get(this.endPoint + "/raw-account");
    }

    getProfileAndDefault() {
        return this.getAuthTokenRequest().get(this.endPoint + "/profile-and-default");
    }

    getAccountAndDefault() {
        return this.getAuthTokenRequest().get(this.endPoint + "/account-and-default");
    }
}
